// 获取屏幕中心点坐标
export function getClientCenter() {
  const { clientWidth, clientHeight } = document.documentElement;
  return {
    x: parseInt(clientWidth / 2),
    y: parseInt(clientHeight / 2),
  };
}
